export enum ActivityRoutes {
  sendActivity = "sendActivity",
}
